import { ValidationFailAPIResponse } from '@avicennapharmacy/managemymeds-shared';

export default ({ reasons }: ValidationFailAPIResponse) => reasons.map(({ field, reason }) => `${field} ${reason}`);
